import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { HelpCircle } from 'lucide-react';
export function Objection() {
  return <Section background="white" data-id="element-142">
      <FadeIn data-id="element-143">
        <div className="max-w-2xl mx-auto text-center" data-id="element-144">
          <div className="inline-block p-3 bg-gray-100 rounded-full mb-6" data-id="element-145">
            <HelpCircle className="h-8 w-8 text-gray-500" data-id="element-146" />
          </div>

          <h2 className="text-3xl font-serif font-bold mb-6 text-[#1A1A1A]" data-id="element-147">
            "¿Y si me duele?"
          </h2>

          <div className="prose prose-lg mx-auto text-gray-600" data-id="element-148">
            <p className="mb-4" data-id="element-149">
              Te entiendo. Por eso el plan no se apoya en valentía.
              <br data-id="element-150" />
              <span className="font-bold text-[#1B4332]" data-id="element-151">
                Se apoya en reglas.
              </span>
            </p>

            <p className="mb-6" data-id="element-152">
              Si el semáforo dice amarillo, ajustás. Si dice rojo, retrocedés a
              Nivel 0.
            </p>

            <p className="italic font-medium text-[#1A1A1A]" data-id="element-153">
              Eso es lo que evita el ciclo de "me entusiasmé → me inflamé →
              abandoné".
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
}